export default "__VITE_ASSET__2c74bf8d__"